import { ActionIcon, Tooltip } from "@mantine/core";
import { ReactNode } from "react";
import classes from "./list.module.css";

export type RowActionIntent =
  | "view"
  | "pdf"
  | "edit"
  | "pay"
  | "ebarimt"
  | "danger"
  | "default";

type Props = {
  intent: RowActionIntent;
  icon: ReactNode;
  label: string;
  onClick: () => void;
  disabled?: boolean;
  disabledReason?: string;
  loading?: boolean;
};

export function RowActionButton({
  intent,
  icon,
  label,
  onClick,
  disabled,
  disabledReason,
  loading,
}: Props) {
  const isDisabled = disabled || loading;
  const tooltip = isDisabled && disabledReason ? disabledReason : label;
  // aria-disabled (disabled биш): гараар focus авч, tooltip-ээс шалтгааныг (эрхийн код) уншина.

  return (
    <Tooltip label={tooltip} withArrow disabled={!tooltip}>
      <ActionIcon
        className={classes.rowActionBtn}
        data-intent={intent}
        variant="subtle"
        color="gray"
        size="lg"
        radius="md"
        aria-label={label}
        aria-disabled={isDisabled || undefined}
        data-disabled={isDisabled || undefined}
        onClick={isDisabled ? (event) => event.preventDefault() : onClick}
        loading={loading}
      >
        {icon}
      </ActionIcon>
    </Tooltip>
  );
}
